import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectTimeline = () => {
  const timelineEvents = [
    {
      id: 1,
      phase: 'Project Initiation',
      date: 'January 2022',
      status: 'completed',
      title: 'Partnership Formation',
      description: 'Established cross-border partnerships and secured EU funding approval for heritage tourism development.',
      icon: 'Users'
    },
    {
      id: 2,
      phase: 'Research & Planning',
      date: 'March 2022',
      status: 'completed',
      title: 'Heritage Site Documentation',
      description: 'Comprehensive mapping and documentation of cultural and natural heritage sites across both countries.',
      icon: 'MapPin'
    },
    {
      id: 3,
      phase: 'Trail Development',
      date: 'September 2022',
      status: 'completed',
      title: 'Thematic Trail Design',
      description: 'Created 8 unique thematic trails connecting heritage sites with local tourism offerings.',
      icon: 'Route'
    },
    {
      id: 4,
      phase: 'Digital Platform',
      date: 'June 2023',
      status: 'completed',
      title: 'Interactive Map Launch',
      description: 'Launched digital platform with interactive mapping and heritage site information system.',
      icon: 'Smartphone'
    },
    {
      id: 5,
      phase: 'Community Engagement',
      date: 'October 2023',
      status: 'in-progress',
      title: 'Local Partnership Development',
      description: 'Ongoing collaboration with local communities to integrate authentic experiences and services.',
      icon: 'Heart'
    },
    {
      id: 6,
      phase: 'Marketing & Promotion',
      date: 'February 2024',
      status: 'upcoming',
      title: 'International Tourism Promotion',
      description: 'Launch comprehensive marketing campaign targeting international heritage tourism markets.',
      icon: 'Globe'
    },
    {
      id: 7,
      phase: 'Sustainability',
      date: 'December 2024',
      status: 'upcoming',
      title: 'Long-term Sustainability Plan',
      description: 'Implement sustainable tourism practices and establish ongoing maintenance framework.',
      icon: 'Leaf'
    }
  ];

  const getStatusColor = (status) => {
    switch (status) {
      case 'completed':
        return 'text-success bg-success/10 border-success/20';
      case 'in-progress':
        return 'text-warning bg-warning/10 border-warning/20';
      case 'upcoming':
        return 'text-muted-foreground bg-muted border-border';
      default:
        return 'text-muted-foreground bg-muted border-border';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'completed':
        return 'CheckCircle';
      case 'in-progress':
        return 'Clock';
      case 'upcoming':
        return 'Calendar';
      default:
        return 'Circle';
    }
  };

  return (
    <div className="bg-card rounded-lg shadow-card p-8">
      <div className="text-center mb-8">
        <h2 className="font-heading font-semibold text-2xl text-foreground mb-3">
          Project Timeline
        </h2>
        <p className="text-muted-foreground max-w-2xl mx-auto">
          Track our progress from initial partnership formation to sustainable tourism implementation 
          across the heritage trail network.
        </p>
      </div>
      <div className="relative">
        {/* Timeline Line */}
        <div className="absolute left-8 top-0 bottom-0 w-0.5 bg-border hidden md:block" />

        <div className="space-y-8">
          {timelineEvents?.map((event, index) => (
            <div key={event?.id} className="relative">
              {/* Timeline Dot */}
              <div className="hidden md:flex absolute left-6 w-4 h-4 bg-card border-2 border-primary rounded-full items-center justify-center">
                <div className="w-2 h-2 bg-primary rounded-full" />
              </div>

              {/* Content */}
              <div className="md:ml-16">
                <div className="bg-surface rounded-lg p-6">
                  <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4 mb-4">
                    <div className="flex items-start gap-3">
                      <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${getStatusColor(event?.status)} border`}>
                        <Icon name={event?.icon} size={20} />
                      </div>
                      <div>
                        <div className="flex items-center gap-2 mb-1">
                          <h3 className="font-heading font-semibold text-base text-foreground">
                            {event?.title}
                          </h3>
                          <Icon 
                            name={getStatusIcon(event?.status)} 
                            size={16} 
                            className={getStatusColor(event?.status)?.split(' ')?.[0]} 
                          />
                        </div>
                        <p className="text-sm text-muted-foreground font-medium">
                          {event?.phase}
                        </p>
                      </div>
                    </div>
                    
                    <div className="flex items-center gap-2 text-sm text-muted-foreground">
                      <Icon name="Calendar" size={16} />
                      <span>{event?.date}</span>
                    </div>
                  </div>
                  
                  <p className="text-sm text-muted-foreground leading-relaxed">
                    {event?.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProjectTimeline;